import Controller from '@ember/controller';
import { service } from '@ember/service';
import type { HotelAndMarketServiceWithHotel } from 'lumen/services/hotel-and-market';

export default class HotelRevpakExportsController extends Controller {
  @service('hotel-and-market')
  declare hotelAndMarketService: HotelAndMarketServiceWithHotel;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get iframeQPs() {
    return {
      iframe: 1,
      origin: window.location.origin,
      subscriptionId: this.hotelAndMarketService.hotel.id,
    };
  }
}
